import {
  Card,
  CardBody,
  CardFooter,
  IconButton,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import React, { useEffect, useState } from "react"
import { BASEURL, calculateDaysLeft } from "../../../util"
import useSWR from "swr"
import {
  CustomBarChart,
  CustomDeleteModal,
  CustomPieChart,
  DetailDrawer,
  HeaderIcon,
  RenderDetail,
} from "../../../components"
import { CampaignType } from "../../../types/campaign"
import { UserType } from "../../../types/user"
import dayjs from "dayjs"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import { RiAdminLine, RiCustomerService2Line } from "react-icons/ri"
import { MdOutlinePolicy } from "react-icons/md"
import { FaMoneyBillWave } from "react-icons/fa6"
import { TbPencilDiscount } from "react-icons/tb"
import {
  BROKERCOMPANYDASHBOARD,
  INSURANCECOMPANYDASHBOARD,
} from "../../../GraphQl/queries"
import { useQuery } from "@apollo/client"
import { InsuranceDahboardType } from "../../../types/query"
import CustomVolumeBarChart, {
  CustomBarChartForPremium,
  CustomPolicyNumberBarChart,
  CustomPremiumNumberBarChart,
  CustomVolumeBarChartBusClass,
} from "../../../components/charts/barChart"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { toast } from "react-toastify"
import CustomVolumeBarChartInsur from "../../../components/charts/barChart"

type ChartType = {
  premiums_per_business_class: Array<{
    name: string
    total_premium: number
  }>
  premiums_number_per_business_class: Array<{
    name: string
    record_count: number
  }>
  volumes_generated_by_staff: Record<string, number>
}

type SumField = {
  __typename: string
  amount: number | null
  commission_amount?: number | null
}

type AggregateData = {
  __typename: string
  aggregate: {
    __typename: string
    count?: number
    sum?: SumField
  }
}

type PremiumPaidData = {
  __typename: string
  total_amount_sold: number
}

type ViewBrokerPremiumData = {
  __typename: string
  name: string
  total_premium: number
}

type ViewBrokerPolicyData = {
  __typename: string
  company_name: string
  company_id: string
  policy_count: number
  total_commission: number
  business_class_name: string
  total_premium: number
}

type ChartDataComm = {
  __typename: string
  business_class_name: string
  name: string
  total_commission: number
}
type ChartDataMon = {
  __typename: string
  month_category: string
  total_commission: number
  business_class_name: string
  commission_name: string
}

type ResponseData = {
  total_policy_holders: AggregateData
  company_staff_aggregate: AggregateData
  sub_agents_aggregate: AggregateData
  insurers: AggregateData
  new_policy: AggregateData
  lapse_policy: AggregateData
  renewed_policy: AggregateData
  tax_payable_aggregate: AggregateData
  active_policy: AggregateData
  premium_paid: PremiumPaidData[]
  paid_commissions: AggregateData
  pending_commissions: AggregateData
  view_broker_total_premiums_of_business_class: ViewBrokerPremiumData[]
  view_broker_company_policy_count_of_business_class: ViewBrokerPolicyData[]
  bar_chart_data_commissions: ChartDataComm[]
  month_bar_chart_data: ChartDataMon[]
  view_commission_per_company: [
    {
      __typename: string
      business_class_name: string
      insurance_company_name: string
      total_commission: number
    }
  ]
  view_commission_per_business_class: [
    {
      __typename: string
      business_class_name: string
      total_commission: number
    }
  ]
}

function DashboardOverview() {
  const [loadingData, setLoading] = useState(true)
  const [commissions, setCommissions] = useState<ChartType | null>(null)
  const {
    companyId,
    token,
    user: stateUser,
  } = useSelector((state: RootState) => state.auth)
  const [colors, setColors] = useState<string[]>()

 const { data, loading, refetch } = useQuery<ResponseData>(
  BROKERCOMPANYDASHBOARD,
  {
    skip: !companyId,
    variables: { id: companyId },
  }
)

 

  const fetchPaidComissions = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/brokers_graph_data`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            broker_id: companyId,
          }),
        }
      )
      const req = await res.json()
      if (res.ok) {
        if (req?.error === 404) {
          setCommissions(null)
        } else {
          setCommissions(req?.data)
        }
      }
    } catch (error) {
      toast.error("Failed to fetch commissions. Refresh to try again")
    } finally {
      setLoading(false)
    }
    //-------------------------
  }

  useEffect(() => {
    fetchPaidComissions()
  }, [])



  return (
    <>
      <CustomHeader title="Overview" />
      <div className="w-full">
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:lg:gap-4 lg:gap-5">
          <Card className="bg-brand-purple rounded-lg  shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.company_staff_aggregate?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  staff
                </Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>
          {/* <Card className="bg-brand-danger rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    (
                      (data?.tax_payable_aggregate?.aggregate?.sum
                        ?.amount as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Total Tax
                </Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card> */}
          <Card className="bg-brand-danger rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.total_policy_holders?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Policyholders
                </Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>
          {/* <Card className="bg-brand-info rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.sub_agents_aggregate?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Sub agents
                </Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card> */}

          <Card className="bg-[#003566] rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.active_policy?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Active Policies
                </Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-[#004e98] rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.new_policy?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  New Policies
                </Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-brand-danger rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.insurers?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Insurance Companies
                </Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-[#b1740f] rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.renewed_policy?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Renewed Policies
                </Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-[#403d39] rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    data?.lapse_policy?.aggregate?.count
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Lapsed Policies
                </Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-brand-danger rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    (data?.paid_commissions?.aggregate?.sum
                      ?.commission_amount ?? 0) +
                    (data?.pending_commissions?.aggregate?.sum
                      ?.commission_amount ?? 0)
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Total Commissions (Recievables)
                </Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>

          <Card className="bg-brand-cyan rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    (
                      (data?.pending_commissions?.aggregate?.sum
                        ?.commission_amount as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  pending commissions (Recievables)
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-brand-cyan rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    (
                      (data?.paid_commissions?.aggregate?.sum
                        ?.commission_amount as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  paid commissions (Recievables)
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
              
            </div>
          </Card>
          <Card className="bg-red-400 rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    (
                      (data?.premium_paid[0]?.total_amount_sold as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Premiums Paid
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          {data?.view_broker_total_premiums_of_business_class.map((item) => (
            <Card className="bg-brand-purple rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
              <div className="flex flex-row justify-between">
                <div>
                  <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                    {loading ? (
                      <Spinner className="mb-2 text-white" />
                    ) : (
                      "GH₵" +
                      ((item.total_premium as any) ?? 0).toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )
                    )}
                  </Typography>
                  <Typography className="text-sm uppercase font-normal text-white">
                    {item?.name} premium
                  </Typography>
                </div>
                <FaMoneyBillWave size={28} color="#cbcbcb" />
              </div>
            </Card>
          ))}
          {/* {data?.view_broker_company_policy_count_of_business_class?.map(
            (item) => (
              <Card className="bg-[#003566] rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
                <div className="flex flex-row justify-between">
                  <div>
                    <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                      {loading ? (
                        <Spinner className="mb-2 text-white" />
                      ) : (
                        item?.policy_count
                      )}
                    </Typography>
                    <Typography className="text-sm uppercase font-normal text-white">
                      {item?.business_class_name} policies
                    </Typography>
                  </div>
                  <MdOutlinePolicy size={28} color="#cbcbcb" />
                </div>
              </Card>
            )
          )} */}

          {/* <Card className="bg-brand-gray rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    (
                      (data?.all_commissions?.aggregate?.sum
                        ?.commission_amount as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Commissions
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card> */}
          {/* <Card className="bg-[#451e31] rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    (
                      (data?.commission_paid?.aggregate?.sum?.amount as any) ??
                      0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Commissions Paid
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card> */}
          {/* <Card className="bg-[#abc4ff] rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    (
                      (data?.outstanding_commissions?.aggregate?.sum
                        ?.commission_amount as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Commissions Outstanding
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card> */}
        </div>

        <div className="mt-6 w-full grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 md:lg:gap-4 lg:gap-5"></div>
      </div>

      <div className="grid gap-6 my-7 grid-cols-1 lg:grid-cols-2">
        <div className="rounded-xl bg-white py-3">
          <span className="text-sm px-3 mb-4 font-semibold">
            Premiums Per Class of Business
          </span>
          <div className="h-96 w-full mt-10 flex items-center justify-center">
            {loadingData ? (
              <Spinner />
            ) : (
              <CustomBarChart
                data={commissions?.premiums_per_business_class as any}
              />
            )}
          </div>
        </div>

        <div className="rounded-xl bg-white py-3">
          <span className="text-sm px-3 mb-4 font-semibold">
            Number of Polices per Class of Business
          </span>
          <div className="h-96 w-full mt-10 flex items-center justify-center">
            {loadingData ? (
              <Spinner />
            ) : (
              <CustomPremiumNumberBarChart
                data={commissions?.premiums_number_per_business_class as any}
              />
            )}
          </div>
        </div>
      </div>
      <div className="grid gap-6 my-7 grid-cols-1 lg:grid-cols-2 ">
        <div className="rounded-xl bg-white p-3">
          <span className="text-sm p-3 mb-4 font-semibold">
            {/* Volumes generated by Brokers, Agents and Direct Business */}
            Premiums per Insurance Company
          </span>
          <div className="h-96 w-full mt-10 p-0">
            {loading ? (
              <Spinner />
            ) : (
              <CustomBarChartForPremium
                data={
                  data?.view_broker_company_policy_count_of_business_class?.map(
                    (item) => ({
                      name: `${item?.company_name}/${item?.business_class_name}`,
                      total_premium: item.total_premium,
                    })
                  ) as any
                }
              />
            )}
          </div>
        </div>

        <div className="rounded-xl bg-white p-3 ">
          <span className="text-sm p-3 mb-4 font-semibold">
            {/* Volumes generated by Brokers, Agents and Direct Business */}
            Number of Policies per Insurance Company
          </span>
          <div className="h-96 w-full mt-10 p-0">
            {loading ? (
              <Spinner />
            ) : (
              <CustomPolicyNumberBarChart
                data={
                  data?.view_broker_company_policy_count_of_business_class?.map(
                    (item) => ({
                      name: item.company_name,
                      record_count: item.policy_count,
                    })
                  ) as any
                }
              />
            )}
          </div>
        </div>

        {/* <div className="rounded-xl bg-white p-3">
  <span className="text-sm p-3 mb-4 font-semibold">
    Volumes generated by Branches and Divisions
  </span>
  <div className="h-96 w-full mt-10 flex items-center justify-center">
    {isLoading ? (
      <Spinner />
    ) : (
      <CustomPieChart
        data={
          insurance_companies_graph_data?.premiums_per_business_class as any
        }
      />
    )}
  </div>
</div> */}
      </div>

      <div className="grid gap-6 my-7 grid-cols-1 lg:grid-cols-1 "></div>

      <div className="grid gap-6 my-7 grid-cols-1 lg:grid-cols-2 ">
        <div className="rounded-xl bg-white p-3 ">
          <span className="text-sm p-3 mb-4 font-semibold">
            Commissions per Class of Business
          </span>
          <div className="h-96 w-full mt-10 p-0">
            <CustomVolumeBarChartBusClass
              data={
                data?.view_commission_per_business_class?.map((item) => ({
                  name: item.business_class_name,
                  total_commission: item?.total_commission,
                })) as any
              }
            />
          </div>
        </div>
        <div className="rounded-xl bg-white p-3 ">
          <span className="text-sm p-3 mb-4 font-semibold">
            Commissions generated per insurance company
          </span>
          <div className="h-96 w-full mt-10 p-0">
            <CustomVolumeBarChartInsur
              data={
                data?.view_commission_per_company?.map(
                  (item) => ({
                    name: `${item?.insurance_company_name}/${item?.business_class_name}`,
                    total_commission: item?.total_commission,
                  })
                ) as any
              }
            />
          </div>
        </div>

        {/* <div className="rounded-xl bg-white p-3">
          <span className="text-sm p-3 mb-4 font-semibold">
            Commissions Generated Per Month/Period
          </span>
          <div className="h-96 w-full mt-10 p-0">
            <CustomVolumeBarChart data={data?.month_bar_chart_data as any} />
          </div>
        </div> */}

        {/* <div className="rounded-xl bg-white p-3">
          <span className="text-sm p-3 mb-4 font-semibold">
            Volumes generated by Branches and Divisions
          </span>
          <div className="h-96 w-full mt-10 flex items-center justify-center">
            {isLoading ? (
              <Spinner />
            ) : (
              <CustomPieChart
                data={
                  insurance_companies_graph_data?.premiums_per_business_class as any
                }
              />
            )}
          </div>
        </div> */}
      </div>

      {/* <Card className="rounded-xl w-full overflow-x-scroll">
        <div className="w-full px-5 flex flex-col md:flex-row lg:flex-row md:items-center lg:items-center gap-3 py-4 rounded-txl bg-black">
          <Typography className="text-base text-brand-primary font-semibold">
            Top performing agents
          </Typography>
          <select
            id="filters"
            className="h-10 w-full md:w-1/4 lg:w-1/4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option className="" selected disabled>
              Filter by
            </option>
          </select>
        </div>
        <table className="w-full min-w-max table-auto text-center">
          <thead>
            <tr>
              {TABLE_HEAD.map((head) => (
                <th
                  key={head}
                  className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                >
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="capitalize font-normal leading-none opacity-70"
                  >
                    {head}
                  </Typography>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {TABLE_ROWS.map(
              ({ name, phone, location, total_policy_sold }, index) => {
                const isLast = index === TABLE_ROWS.length - 1;
                const classes = isLast
                  ? "p-4"
                  : "p-4 border-b border-blue-gray-50";

                return (
                  <tr key={name}>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs"
                      >
                        {name}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs"
                      >
                        {phone}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs"
                      >
                        {location}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        as="a"
                        href="#"
                        variant="small"
                        color="blue-gray"
                        className="font-medium"
                      >
                        {total_policy_sold}
                      </Typography>
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </Card> */}
      {/* 
      <div className="grid gap-6 grid-cols-1 lg:grid-cols-3">
        <div className="bg-white w-full col-span-2 h-72 overflow-hidden">
          <Card className="h-full w-full overflow-y-scroll">
            <table className="w-full min-w-max table-auto text-left">
              <thead>
                <tr>
                  {TABLE_HEAD.map((head) => (
                    <th
                      key={head}
                      className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                    >
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal leading-none opacity-70"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {TABLE_ROWS.map(({ name, job, date }, index) => {
                  const isLast = index === TABLE_ROWS.length - 1;
                  const classes = isLast
                    ? "p-4"
                    : "p-4 border-b border-blue-gray-50";

                  return (
                    <tr key={name}>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs"
                        >
                          {name}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs"
                        >
                          {job}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs"
                        >
                          {date}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          as="a"
                          href="#"
                          variant="small"
                          color="blue-gray"
                          className="font-medium"
                        >
                          Edit
                        </Typography>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        </div>
        <div className="bg-white h-64">
          <CustomPieChart />
        </div>
      </div> */}
      <div className="my-28"></div>
    </>
  )
}

export default DashboardOverview
